/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.5 routes of Activo::Application.
 * @version a7629dbf06a74a15ddfa9aaa65eeca4428dcc86189122aef2e0659a8f7048017
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
(typeof window !== 'undefined' ? window : this).ManageRoutes = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using (typeof window !== 'undefined' ? window : this).ManageRoutes = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("NIL", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/activo(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  activo_manage_analytic_articles_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"activo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/add_job_fee(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_job_fee_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_job_fee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id/all_update(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_update_manage_all_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"all_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_stories_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/story_like(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_story_like_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"story_like"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/story_support(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_story_support_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"story_support"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides/batch_create_or_update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_create_or_update_manage_additional_entry_limit_overrides_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[2,[7,"/"],[2,[6,"batch_create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_all_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/contacts(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_article_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_edit_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_invite_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_login_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_logout_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_register_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_templates_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/top(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_top_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"top"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:article_id/contacts(.:format)
   * @param {any} company_name
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_contacts_path: __jsr.r({"company_name":{"r":true},"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /contact(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contact_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_manage_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:id/edit(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_user_article_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:duration/edit(.:format)
   * @param {any} duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_analytic_path: __jsr.r({"duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"duration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/supporter_acquire_settings/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_supporter_acquire_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"supporter_acquire_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/form_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  form_editor_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/form_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  form_editor_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/entry/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limits/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_override_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_overrides_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limits(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limits_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_all_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_all_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:duration(.:format)
   * @param {any} duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_path: __jsr.r({"duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"duration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/:id(.:format)
   * @param {any} analytic_duration
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_article_path: __jsr.r({"analytic_duration":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/:article_id/type(.:format)
   * @param {any} analytic_duration
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_article_type_path: __jsr.r({"analytic_duration":{"r":true},"article_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_articles_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/generals(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_generals_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"generals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/durations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_durations_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"durations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_users_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/additional_questions_duplicate(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_additional_questions_duplicate_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"additional_questions_duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/ads(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_ads_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"ads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/contacts(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/duplicate(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_duplicate_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/google_authorize(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_google_authorize_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"google_authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/preview_token/:id(.:format)
   * @param {any} article_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_preview_token_path: __jsr.r({"article_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_token"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/preview_token(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_preview_tokens_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/tools(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_tools_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/auto_reply_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_auto_reply_setting_path: __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"auto_reply_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/auto_reply_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_auto_reply_settings_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"auto_reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/belonging_people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_belonging_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"belonging_people"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/belonging_people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_belonging_person_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"belonging_people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_bulk_ads_tickets_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_bulk_ads_tickets_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/special_update/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_special_update_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"special_update"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/stripe_subscription(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_stripe_subscription_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"stripe_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id/contact_first_replies(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_contact_first_replies_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"contact_first_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_earned_scout_point_transactions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_earned_scout_point_transactions_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_edit_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/google_authorize(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_google_authorize_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"google_authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_contract(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_job_contract_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_posting_consent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_job_posting_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_posting_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/oauth2callback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_oauth2callback_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"oauth2callback"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/paid_plan_rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_paid_plan_rules_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"paid_plan_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/pictures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_pictures_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/portal_connect(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_portal_connect_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"portal_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/billings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_billings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/onboarding_task_events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_onboarding_task_events_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"onboarding_task_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reply_to_contact_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reply_to_contact_template_path: __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reply_to_contact_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reply_to_contact_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reply_to_contact_templates_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reply_to_contact_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_room_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_rooms_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_rooms_bulk_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_policy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_policy_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/item_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_item_lists_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"item_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/members(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_members_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/scout_points(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_scout_points_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"scout_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sheet_sync_info_of_contacts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sheet_sync_info_of_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sheet_sync_info_of_contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sheet_sync_info_of_contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sheet_sync_info_of_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sheet_sync_info_of_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_stories_bulk_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/story_create(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_story_create_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"story_create"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sub_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sub_tags_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sub_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/supporter_acquire_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_supporter_acquire_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"supporter_acquire_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/toggle(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_toggle_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/top(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_top_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"top"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/update_card(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_update_card_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"update_card"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/write_rule(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_write_rule_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"write_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_manage_article_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_manage_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_analytic_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_article_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_bulk_ads_ticket_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_earned_scout_point_transaction_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_posting_consent/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_job_posting_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_posting_consent"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/portal_connect/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_portal_connect_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"portal_connect"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_story_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/scout_message_rooms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_scout_message_room_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/scout_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_scout_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"scout_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /picture_upload(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  picture_upload_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"picture_upload"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/reply_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_settings_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/reply_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_settings_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/special_update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_update_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"special_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/a/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id/supports(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  supports_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"supports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/templates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  templates_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /entry/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]])}
,
    });
})();
